import {ConfigDataset} from "./config.dataset";
import {CodeDataset} from "./code.dataset";

export type Dataset = ConfigDataset | CodeDataset;
export const Dataset = {...ConfigDataset, ...CodeDataset};
